import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
// eslint-disable-next-line react/prop-types
const VerComentarios = ({ id }) => {
  const [list1, setList1] = useState([]);
  const [expandedComments, setExpandedComments] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const urlendpoint = `https://contratosback.azurewebsites.net/api/v1/ObtenerComentarios/${id}`;

  useEffect(() => {
    const fetchComments = () => {
      axios({
        auth: {
          username: "admin.icontec@icontec.org",
          password: "quAngEraMuSTerGerE",
        },
        method: "get",
        url: urlendpoint,
      })
        .then((res) => {
          if (Array.isArray(res.data)) {
            const sortedComments = res.data.sort(
              (a, b) => new Date(b.fechaCreacion) - new Date(a.fechaCreacion)
            );
            setList1(sortedComments);
          } else {
            console.error("Datos inesperados:", res.data);
          }
        })
        .catch((error) => {
          console.error("Error al obtener los comentarios:", error);
          alert("Hubo un problema al cargar los comentarios");
        });
    };

    fetchComments();
    const intervalId = setInterval(fetchComments, 10000);
    return () => clearInterval(intervalId);
  }, [id]);

  const toggleExpand = (id) => {
    setExpandedComments((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list1.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(list1.length / itemsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const truncateText = (text, limit = 200) =>
    text.length > limit ? text.slice(0, limit) + "..." : text;

  return (
    <Container className="mt--7" fluid>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0">
              <h3 className="mb-0">Comentarios de la solicitud</h3>
            </CardHeader>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th style={{ width: "30%" }}>Usuario / Fecha</th>
                  <th style={{ width: "70%" }}>Comentario</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <div>
                          <strong>{item.nombre}</strong>
                          <br />
                          <small>
                            {new Date(item.fechaCreacion).toLocaleString("es-co", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </small>
                        </div>
                      </td>
                      <td>
                        <div className="bg-light text-dark p-2 rounded">
                          {expandedComments[item.id]
                            ? item.comentarios
                            : truncateText(item.comentarios)}
                          {item.comentarios.length > 200 && (
                            <div>
                              <button
                                className="btn btn-link p-0 mt-1"
                                onClick={() => toggleExpand(item.id)}
                                style={{ fontSize: "0.9rem" }}
                              >
                                {expandedComments[item.id] ? "Ver menos" : "Ver más"}
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No hay comentarios disponibles.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              <nav aria-label="Paginación de comentarios">
                <Pagination className="pagination justify-content-end mb-0">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink onClick={() => handlePageChange(currentPage - 1)}>
                      <i className="fas fa-angle-left" />
                    </PaginationLink>
                  </PaginationItem>
                  {[...Array(totalPages)].map((_, index) => (
                    <PaginationItem key={index} active={index + 1 === currentPage}>
                      <PaginationLink onClick={() => handlePageChange(index + 1)}>
                        {index + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink onClick={() => handlePageChange(currentPage + 1)}>
                      <i className="fas fa-angle-right" />
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </nav>
            </CardFooter>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default VerComentarios;
